import { Review } from '../types/review';

export const REVIEWS: Review[] = [
    {
        id: '019690da-15f8-77fb-b01b-0bfcff2de0a5',
        rating: 4,
        text: ''
    }
];
